
const ModelType = Object.freeze({
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  CLIPBOARD_COPY: 'CLIPBOARD_COPY',
  NUMBER: 'NUMBER',
  NUMBER_INPUT: 'NUMBER_INPUT',
  OPTIONS: 'OPTIONS',
  OPTIONSV2: 'OPTIONSV2',
  CHECKBOX: 'CHECKBOX',
  SWITCH: 'SWITCH',
  TIME_RANGE: 'TIME_RANGE',
  SIGNALS: 'SIGNALS',
  PLOTLINES: 'PLOTLINES',
  PLOTLINES_MODAL: 'PLOTLINES_MODAL',
  PROPERTIES: 'PROPERTIES',
  SUB_DIALOG: 'SUB_DIALOG',
  COLOR_PICKER: 'COLOR_PICKER',
  CODE_EDITOR: 'CODE_EDITOR',
  JSON_EDIT_DIALOG: 'JSON_EDIT_DIALOG',
  TREE_SELECTION: 'TREE_SELECTION',
  NODE_SELECTION: 'NODE_SELECTION',
  NODE_SELECTION_NODES: 'NODE_SELECTION_NODES',
  NODE_SELECTION_ASSETS: 'NODE_SELECTION_ASSETS',
  RADIO_GROUP: 'RADIO_GROUP',
  TOGGLE_GROUP: 'TOGGLE_GROUP',
  DISPLAY_TEXT: 'DISPLAY_TEXT',
  ORG_ID: 'ORG_ID',
  CUSTOM: 'CUSTOM'
});

export default ModelType;
